module.exports = __webpack_public_path__ + "img/agreement_between.46028f25.svg";